import SectionLabel from "./SectionLabel";
import PromineoJsonViewer from "components/common/PromineoJsonViewer";
import { ScrollView } from "devextreme-react";
import PromineoCopyClipboard from "components/common/PromineoCopyClipboard";

interface Props {
  json: object;
  maxHeightClass?: string;
}

export default function RequestJsonViewer(props: Props) {
  const CopyClipboardComponent = () => {
    return (
      <div className="absolute bottom-0 right-2">
        <PromineoCopyClipboard text={JSON.stringify(props.json)} />
      </div>
    );
  };

  return (
    <div className="relative">
      <SectionLabel label="JSON" />
      <ScrollView>
        <div
          className={`ml-2 mt-2 ${
            props.maxHeightClass ? props.maxHeightClass : "max-h-150"
          }`}
        >
          <PromineoJsonViewer src={props.json} />
        </div>
      </ScrollView>
      <CopyClipboardComponent />
    </div>
  );
}
